// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'

class Wrapper extends React.PureComponent {
  static propTypes = {
    AdvancedSearch: func.isRequired,
    customImportHandler: func,
    change: func.isRequired,
    hasResults: bool,
    highlightRows: bool,
    highlightedRows: array,
    idRoot: string.isRequired,
    showContents: bool.isRequired,
    sourceForm: string.isRequired,
  }

  // if we're being told to show contents, default this to auto so on first render cycle, we're showing stuff.
  state = {
    maxHeight: this.props.showContents ? 'none' : 0,
    overflow: this.props.showContents ? 'visible' : 'hidden',
  }

  componentDidMount () {
    // figure out how to listen for the transitionend event on this client.
    let transitionEnd = (
      (this.wrapperNode.style.transition !== undefined && 'transitionend') ||
      (this.wrapperNode.style.WebkitTransition !== undefined && 'webkitTransitionEnd') ||
      (this.wrapperNode.style.MozTransition !== undefined && 'transitionend') ||
      (this.wrapperNode.style.OTransition !== undefined && 'oTransitionEnd otransitionend') ||
      undefined
    )

    // when a browser doesn't know about CSS transitions, we'll need to accomodate for this
    // by simply toggling between maxHeight 0 and 'none'
    if (transitionEnd === undefined) {
      return this.setState(state => ({
        ...state,
        preventTransition: true,
      }))
    }

    this.wrapperNode.addEventListener(transitionEnd, this.completeTransition)
  }

  componentWillReceiveProps (np, ns) {
    // we only care if the height should be changed or not.
    if (np.showContents === this.props.showContents) {
      return
    }

    // if the browser doesn't know how to handle CSS transitions,
    // just toggle between max-height 0 and 'auto'.
    if (this.state.preventTransition) {
      return this.toggleWithoutTransition(np.showContents)
    }

    // if we were rendering contents at 'auto',
    // switch over to the current fixed value for CSS to properly handle transition.
    if (this.state.maxHeight === 'none') {
      this.setState(state => ({
        ...state,
        maxHeight: this.innerNode.offsetHeight,
      }))
    }

    // the new wrapper height, either based on the natural height of the
    const maxHeight = (
      np.showContents
        ? this.innerNode.offsetHeight
        : 0
    )

    // push this update back one clock cycle so the DOM can update from maxHeight 'none'
    // to a fixed value calculated from this.innerNode.offsetHeight
    setTimeout(() => this.setState(state => ({
      ...state,
      maxHeight,
      overflow: 'hidden',
    })), 1)
  }

  // callback on transitionend
  completeTransition = () => {
    // if we're not closed, then remove the fixed value for max-height.
    // this way any validation errors which can be added or removed will naturally
    // update the layout of the page and wont force wonky overflow.
    if (this.state.maxHeight !== 0) {
      this.setState(state => ({
        ...state,
        maxHeight: 'none',
        overflow: 'visible',
      }))
    }
  }

  // assigns 0 or 'none' for  browsers which do not support CSS transitions
  toggleWithoutTransition = showContents => (
    this.setState(state => ({
      ...state,
      maxHeight: showContents ? 'none' : 0,
    }))
  )

  render () {
    const {
      AdvancedSearch,
      change,
      customImportHandler,
      hasResults,
      highlightRows,
      highlightedRows,
      idRoot,
      sourceForm,
    } = this.props

    // NOTE - we use .clear-both because of the <OuterImport /> in PathDatabaseImport

    return (
      <div
        style={this.state}
        className={'advance-search-wrapper clear-both'}
        ref={wrapperNode => { this.wrapperNode = wrapperNode }}>
        <div ref={innerNode => { this.innerNode = innerNode }}>
          <AdvancedSearch
            change={change}
            customImportHandler={customImportHandler}
            hasResults={hasResults}
            highlightRows={highlightRows}
            highlightedRows={highlightedRows}
            idRoot={idRoot}
            sourceForm={sourceForm} />
        </div>
      </div>
    )
  }
}

export default Wrapper
